import { Routes } from '@angular/router';
import { provideDerivativeSearchDomain } from '@zero/leverage-products/domain';
import { provideChildOnboardingStore, provideOnboardingDomain } from '@zero/onboarding/domain';
import { CustomerGuard, KYCDoneGuard } from '@zero/shared/util-web-app-services';

export const APP_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('@zero/login/feature-login/web').then((m) => m.USER_WEB_ROUTES),
  },
  {
    path: 'meindepot',
    canActivate: [CustomerGuard],
    loadChildren: () => import('@zero/depot/feature-depot/web').then((m) => m.DEPOT_WEB_ROUTES),
  },
  {
    path: 'depot-eroeffnen',
    loadChildren: () => import('@zero/onboarding/feature-onboarding/web').then((m) => m.ONBOARDING_WEB_ROUTES),
    providers: [provideOnboardingDomain()],
  },
  {
    path: 'login/registrierungsbestaetigung',
    loadComponent: () => import('@zero/onboarding/feature-onboarding/web').then((m) => m.LoginAfterEmailConfirmationComponent),
    providers: [provideOnboardingDomain()],
  },
  {
    path: 'kinderdepot',
    canActivate: [CustomerGuard],
    loadChildren: () => import('@zero/onboarding/feature-child-onboarding').then((m) => m.CHILD_ONBOARDING_ROUTES),
    providers: [provideOnboardingDomain(), provideChildOnboardingStore()],
  },
  {
    path: 'identifikation_abgebrochen',
    redirectTo: 'depot-eroeffnen/identifikation_abgebrochen',
  },
  {
    path: 'identifikation_erfolgreich',
    redirectTo: 'depot-eroeffnen/identifikation_erfolgreich',
  },
  {
    path: 'verwaltung',
    canActivate: [CustomerGuard],
    loadChildren: () => import('@zero/self-service/feature-self-service/web').then((m) => m.USER_SELF_SERVICE_WEB_ROUTES),
  },
  {
    path: 'posteingang',
    canActivate: [CustomerGuard],
    loadChildren: () => import('@zero/postbox/feature-postbox/web').then((m) => m.POSTBOX_WEB_ROUTES),
  },
  {
    path: 'handelbare-produkte',
    loadChildren: () => import('@zero/search/feature-tradable-products/web').then((m) => m.TRADABLE_PRODUCTS_WEB_ROUTES),
  },
  {
    path: 'hebelprodukte',
    canActivate: [CustomerGuard],
    providers: [provideDerivativeSearchDomain()],
    loadChildren: () => import('@zero/leverage-products/feature-leverage-products/web').then((m) => m.LEVERAGE_PRODUCTS_WEB_ROUTES),
  },
  {
    path: 'watchlist',
    canActivate: [KYCDoneGuard],
    loadChildren: () => import('@zero/watchlist/feature-watchlist/web').then((m) => m.WATCHLIST_WEB_ROUTES),
  },
  {
    path: 'uebersicht',
    canActivate: [KYCDoneGuard],
    loadChildren: () => import('@zero/home/feature-home/web').then((m) => m.HOME_WEB_ROUTES),
  },
  {
    path: 'sparplaene',
    canActivate: [CustomerGuard],
    loadChildren: () => import('@zero/saving-plans/feature-saving-plans/web').then((m) => m.SAVINGS_PLAN_WEB_ROUTES),
  },
  {
    path: 'krypto',
    canActivate: [CustomerGuard],
    loadChildren: () => import('@zero/crypto/feature-crypto-overview/web').then((m) => m.CRYPTO_WEB_ROUTES),
  },
  {
    path: 'depotwechsel-starten',
    canActivate: [CustomerGuard],
    loadChildren: () => import('@zero/self-service/feature-depot-transfer/web').then((m) => m.DEPOT_TRANSFER_WEB_ROUTES),
  },
  {
    path: 'bezugsrecht',
    canActivate: [CustomerGuard],
    loadChildren: () => import('@zero/bezugsrecht/feature-bezugsrecht/web').then((m) => m.BEZUGSRECHT_WEB_ROUTES),
  },
  {
    path: 'teilrecht',
    canActivate: [CustomerGuard],
    loadChildren: () => import('@zero/bezugsrecht/feature-teilrecht/web').then((m) => m.TEILRECHT_WEB_ROUTES),
  },
  {
    path: 'wahldividende',
    canActivate: [CustomerGuard],
    loadChildren: () => import('@zero/bezugsrecht/feature-wahldividende/web').then((m) => m.WAHLDIVIDENDE_WEB_ROUTES),
  },
  {
    path: 'oauth',
    loadChildren: () => import('@zero/login/feature-oauth-login/web').then((m) => m.OAUTH_LOGIN_WEB_ROUTES),
  },
  {
    path: 'instrument',
    canActivate: [KYCDoneGuard],
    loadChildren: () => import('@zero/instrument-details/feature-instrument-details/web').then((m) => m.INSTRUMENT_DETAILS_WEB_ROUTES),
  },
  {
    path: 'statistik',
    canActivate: [CustomerGuard],
    loadChildren: () => import('@zero/statistics/feature-statistics/web').then((m) => m.STATISTICS_WEB_ROUTES),
  },
  {
    path: 'meine-orders',
    canActivate: [CustomerGuard],
    loadChildren: () => import('@zero/order/feature-order/web').then((m) => m.ORDER_WEB_ROUTES),
  },
  {
    path: 'depotkredit',
    canActivate: [CustomerGuard],
    loadChildren: () => import('@zero/lombard/feature-lombard/web').then((m) => m.LOMBARD_ROUTES),
  },
  {
    path: 'trading',
    canActivate: [CustomerGuard],
    loadChildren: () => import('@zero/trading-tools/feature-trading-tools/web').then((m) => m.TRADING_TOOLS_WEB_ROUTES),
  },
  {
    path: 'etfs',
    canActivate: [CustomerGuard],
    loadChildren: () => import('@zero/asset-class-overview/feature-etfs/web').then((m) => m.ETF_OVERVIEW_ROUTES),
  },
  {
    path: 'aktien',
    canActivate: [CustomerGuard],
    loadChildren: () => import('@zero/asset-class-overview/feature-stocks/web').then((m) => m.STOCK_OVERVIEW_ROUTES),
  },
  { path: '**', redirectTo: '/', pathMatch: 'full' },
];
